import React, { useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import DragIndicatorRoundedIcon from "@mui/icons-material/DragIndicatorRounded";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";

// Aramak Data
const aramakAreaTypes = [
  { id: 1, code: "1200.35", description: "Alcove" },
  { id: 2, code: "1800.01", description: "Animal Facilities" },
  { id: 3, code: "1600.01", description: "Apartment" },
  { id: 4, code: "1800.02", description: "Armory/ROTC" },
  { id: 5, code: "1800.20", description: "Art Studio" },
  { id: 6, code: "1200.02", description: "Athletic/Phys Ed" },
  { id: 7, code: "1200.01", description: "Auditorium/Assembly" },
  { id: 8, code: "1300.01", description: "Baseball" },
  { id: 9, code: "1200.33", description: "Bleachers" },
  { id: 10, code: "2100.01", description: "Boiler/Chiller Room" },
  { id: 11, code: "1200.03", description: "Break Room" },
  { id: 12, code: "1100.01", description: "Bridge/Tunnel" },
  { id: 13, code: "1200.30", description: "Cafeteria" },
  { id: 14, code: "1800.23", description: "Central Sterile/Autoclave" },
  { id: 15, code: "2100.02", description: "Central Utility Plant" },
  { id: 16, code: "1800.03", description: "Chapel" },
  { id: 17, code: "1200.04", description: "Classroom" },
  { id: 18, code: "1800.04", description: "Clinic" },
  { id: 19, code: "1800.05", description: "Computer/Telecomm" },
  { id: 20, code: "1200.05", description: "Conference Room" },
  { id: 21, code: "1200.06", description: "Copy Room/File Room" },
  { id: 22, code: "1100.02", description: "Corridor" },
  { id: 23, code: "1100.03", description: "Covered Walkway" },
  { id: 24, code: "1500.01", description: "Crawlspace" },
  { id: 25, code: "1000.01", description: "Custodial Closet" },
  { id: 26, code: "1200.07", description: "Dance Studio" },
  {
    id: 27,
    code: "1800.06",
    description: "Daycare/Child Care/PreK or Kindergarten",
  },
  { id: 28, code: "1800.07", description: "Dining Room" },
  { id: 29, code: "1600.05", description: "Dorm Room w/ Toilet" },
  { id: 30, code: "1600.04", description: "Dorm Room w/o Toilet" },
  { id: 31, code: "1600.02", description: "Double Bedroom" },
  { id: 32, code: "1200.08", description: "Dressing Room" },
  { id: 33, code: "2100.03", description: "Electrical" },
  { id: 34, code: "1100.04", description: "Elevator" },
  { id: 35, code: "1100.05", description: "Entrance" },
  { id: 36, code: "1100.06", description: "Escalator" },
  { id: 37, code: "1800.08", description: "Exam Room" },
  { id: 38, code: "1300.02", description: "Field" },
  { id: 39, code: "1200.25", description: "Field House" },
  { id: 40, code: "1100.07", description: "Fire Escape" },
  { id: 41, code: "1200.09", description: "Fitness Room" },
  { id: 42, code: "1300.03", description: "Football" },
  { id: 43, code: "2100.04", description: "Fuel Storage Room" },
  { id: 44, code: "1800.21", description: "Gallery/Museum" },
  { id: 45, code: "1800.10", description: "Greenhouse Plant Area" },
  { id: 46, code: "1200.26", description: "Gymnasium/Court" },
  { id: 47, code: "1800.11", description: "Hazmat Storage" },
  { id: 48, code: "2000.01", description: "Inactive Area" },
  { id: 49, code: "1800.09", description: "Kitchen/Food Production" },
  { id: 50, code: "1200.27", description: "Kitchenette" },
  { id: 51, code: "1400.01", description: "Lab-Classroom" },
  { id: 52, code: "1400.02", description: "Lab-Research" },
  { id: 53, code: "1200.10", description: "Laundry" },
  { id: 54, code: "1200.11", description: "Lecture Hall" },
  { id: 55, code: "1900.01", description: "Library" },
  { id: 56, code: "2100.05", description: "Lift Station" },
  { id: 57, code: "1000.02", description: "Loading Dock" },
  { id: 58, code: "1100.08", description: "Lobby" },
  { id: 59, code: "1200.12", description: "Locker Room" },
  { id: 60, code: "1200.13", description: "Lounge" },
  { id: 61, code: "1500.06", description: "Maintenance Shop" },
  { id: 62, code: "1500.02", description: "Mechanical Room" },
  { id: 63, code: "1800.12", description: "Media Center" },
  { id: 64, code: "1800.13", description: "Media Production" },
  { id: 65, code: "1700.01", description: "Mens Restroom" },
  { id: 66, code: "1200.14", description: "Merchandising" },
  { id: 67, code: "2100.06", description: "Meter" },
  { id: 68, code: "1200.15", description: "Multipurpose Room" },
  { id: 69, code: "1200.16", description: "Music Room" },
  { id: 70, code: "1800.19", description: "Nurses Station" },
  { id: 71, code: "1800.17", description: "Nursing Office" },
  { id: 72, code: "1200.17", description: "Office/Cubicle" },
  { id: 73, code: "1200.18", description: "Other" },
  { id: 74, code: "1300.04", description: "Parking Lot" },
  { id: 75, code: "1500.03", description: "Penthouse" },
  { id: 76, code: "1300.05", description: "Pond" },
  { id: 77, code: "2100.07", description: "Pump Room" },
  { id: 78, code: "1200.36", description: "Reception" },
  { id: 79, code: "1200.19", description: "Recreation" },
  { id: 80, code: "1500.04", description: "Roof" },
  { id: 81, code: "1200.23", description: "Running Track" },
  { id: 82, code: "1500.05", description: "Shaft or Tunnel" },
  { id: 83, code: "1300.06", description: "Shed" },
  { id: 84, code: "1800.14", description: "Shop" },
  { id: 85, code: "1200.20", description: "Shower Room" },
  { id: 86, code: "1600.03", description: "Single Bedroom" },
  { id: 87, code: "1300.07", description: "Soccer" },
  { id: 88, code: "1200.34", description: "Stadium Seating" },
  { id: 89, code: "1200.21", description: "Stage" },
  { id: 90, code: "1100.09", description: "Stairs" },
  { id: 91, code: "1200.22", description: "Storage Room-Cleanable" },
  { id: 92, code: "1200.32", description: "Storage Room-Non Cleanable" },
  { id: 93, code: "1900.02", description: "Study Room" },
  { id: 94, code: "1800.22", description: "Surgical" },
  { id: 95, code: "1800.15", description: "Swimming Pool" },
  { id: 96, code: "1800.18", description: "Swimming Pool Deck" },
  { id: 97, code: "2100.08", description: "Tanks" },
  { id: 98, code: "1700.02", description: "Toilet with Bath" },
  { id: 99, code: "1000.03", description: "Trash Room" },
  { id: 100, code: "1300.08", description: "Turf Area" },
  { id: 101, code: "2000.02", description: "Unfinished Area" },
  { id: 102, code: "1700.03", description: "Unisex Restroom" },
  { id: 103, code: "1800.16", description: "Vehicle Storage" },
  { id: 104, code: "1200.31", description: "Vending" },
  { id: 105, code: "1200.24", description: "Waiting Room" },
  { id: 106, code: "2100.09", description: "Water Tower" },
  { id: 107, code: "1200.28", description: "Weight Room" },
  { id: 108, code: "1700.04", description: "Women Restroom" },
  { id: 109, code: "1200.29", description: "Work Room" },
];

const aramakCustodialSpaceTypes = [
  { id: 1, description: "Alcove" },
  { id: 2, description: "Animal Facilities" },
  { id: 3, description: "Armory/ROTC" },
  { id: 4, description: "Art Studio" },
  { id: 5, description: "Athletic/Phys Ed" },
  { id: 6, description: "Auditorium/Assembly" },
  { id: 7, description: "Bleachers" },
  { id: 8, description: "Break Room" },
  { id: 9, description: "Bridge/Tunnel" },
  { id: 10, description: "Cafeteria" },
  { id: 11, description: "Central Sterile/Autoclave" },
  { id: 12, description: "Chapel" },
  { id: 13, description: "Classroom" },
  { id: 14, description: "Clinic" },
  { id: 15, description: "Computer/Telecomm" },
  { id: 16, description: "Conference Room" },
  { id: 17, description: "Copy Room/File Room" },
  { id: 18, description: "Corridor" },
  { id: 19, description: "Covered Walkway" },
  { id: 20, description: "Custodial Closet" },
  { id: 21, description: "Dance Studio" },
  { id: 22, description: "Daycare" },
  { id: 23, description: "Dining Room" },
  { id: 24, description: "Dorm Room w/ Toilet" },
  { id: 25, description: "Dorm Room w/o Toilet" },
  { id: 26, description: "Double Bedroom" },
  { id: 27, description: "Dressing Room" },
  { id: 28, description: "Elevator" },
  { id: 29, description: "Entrance" },
  { id: 30, description: "Escalator" },
  { id: 31, description: "Exam Room" },
  { id: 32, description: "Field House" },
  { id: 33, description: "Fire Escape" },
  { id: 34, description: "Fitness Room" },
  { id: 35, description: "Gallery/Museum" },
  { id: 36, description: "Greenhouse Plant Area" },
  { id: 37, description: "Gymnasium/Court" },
  { id: 38, description: "Hazmat Storage" },
  { id: 39, description: "Kitchen/Food Production" },
  { id: 40, description: "Kitchenette" },
  { id: 41, description: "Lab-Classroom" },
  { id: 42, description: "Lab-Research" },
  { id: 43, description: "Laundry" },
  { id: 44, description: "Lecture Hall" },
  { id: 45, description: "Library" },
  { id: 46, description: "Loading Dock" },
  { id: 47, description: "Lobby" },
  { id: 48, description: "Locker Room" },
  { id: 49, description: "Lounge" },
  { id: 50, description: "Media Center" },
  { id: 51, description: "Media Production" },
  { id: 52, description: "Merchandising" },
  { id: 53, description: "Multipurpose Room" },
  { id: 54, description: "Music Room" },
  { id: 55, description: "Nurses Station" },
  { id: 56, description: "Nursing Office" },
  { id: 57, description: "Office/Cubicle" },
  { id: 58, description: "Reception" },
  { id: 59, description: "Recreation" },
  { id: 60, description: "Restroom" },
  { id: 61, description: "Running Track" },
  { id: 62, description: "Shower Room" },
  { id: 63, description: "Single Bedroom" },
  { id: 64, description: "Stadium Seating" },
  { id: 65, description: "Stage" },
  { id: 66, description: "Stairs" },
  { id: 67, description: "Storage Room-Cleanable" },
  { id: 68, description: "Study Room" },
  { id: 69, description: "Surgical" },
  { id: 70, description: "Swimming Pool Deck" },
  { id: 71, description: "Trash Room" },
  { id: 72, description: "Vending" },
  { id: 73, description: "Waiting Room" },
  { id: 74, description: "Weight Room" },
  { id: 75, description: "Work Room" },
];

const aramakFloorTypes = [
  { id: 1, code: "Ceramic-W/O Finish", description: "Ceramic-W/O Finish" },
  { id: 2, code: "Concrete-W/O Finish", description: "Concrete-W/O Finish" },
  { id: 3, code: "OHS-W/Finish", description: "Linoleum-W/Finish" },
  {
    id: 4,
    code: "M & T - W/Finish",
    description: "Marble & Terrazzo W/Finish",
  },
  {
    id: 5,
    code: "M & T-W/O Finish",
    description: "Marble & Terrazzo-W/O Finish",
  },
  {
    id: 6,
    code: "OHS-W/Finish",
    description: "No-Wax Vinyl Flooring-W/Finish",
  },
  {
    id: 7,
    code: "No-Wax VF-W/O Finish",
    description: "No-Wax Vinyl Flooring-W/O Finish",
  },
  { id: 8, code: "OHS-W/Finish", description: "Other Hard Surface-W/Finish" },
  {
    id: 9,
    code: "OHS-W/O Finish",
    description: "Other Hard Surface-W/O Finish",
  },
  { id: 10, code: "OHS-W/O Finish", description: "Porcelain-W/O Finish" },
  { id: 11, code: "Rubber-W/O Finish", description: "Rubber-W/O Finish" },
  { id: 12, code: "Sheet Vinyl-W/Finish", description: "Sheet Vinyl-W/Finish" },
  { id: 13, code: "VAT-W/Finish", description: "Vinyl Asbestos Tile-W/Finish" },
  {
    id: 14,
    code: "VCT-W/Finish",
    description: "Vinyl Composition Tile-W/Finish",
  },
  { id: 15, code: "Wood-W/Finish", description: "Wood-W/Finish" },
  { id: 16, code: "Wood-W/O Finish", description: "Wood-W/O Finish" },
  { id: 17, code: "Hard Surface", description: "Hard Surface" },
  { id: 18, code: "Carpet", description: "Carpet" },
];

const sectionTitleStyle = {
  fontSize: 12,
  fontWeight: 700,
  color: "#556987",
  marginBottom: 8,
};

const inputStyle = {
  width: "100%",
  border: "1px solid #d6dce5",
  borderRadius: 6,
  padding: "8px 10px",
  fontSize: 12,
  color: "#1f2a44",
  outline: "none",
};

const labelStyle = {
  display: "block",
  fontSize: 11,
  color: "#7d8da6",
  marginBottom: 4,
};

const ActionButton = ({ children, onClick, disabled, variant = "primary" }) => {
  const isPrimary = variant === "primary";
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      style={{
        border: "none",
        borderRadius: 6,
        padding: "8px 14px",
        minWidth: 88,
        fontSize: 12,
        fontWeight: 500,
        color: isPrimary ? "#fff" : "#4e5d78",
        background: disabled ? "#dbe2eb" : isPrimary ? "#112138" : "#eef2f7",
        cursor: disabled ? "not-allowed" : "pointer",
      }}
    >
      {children}
    </button>
  );
};

const normalizePolygonPoints = (points) => {
  if (!Array.isArray(points)) return [];

  return points
    .map((point) => ({
      x: Number(point?.x),
      y: Number(point?.y),
    }))
    .filter((point) => Number.isFinite(point.x) && Number.isFinite(point.y));
};

const polygonPointsToWkt = (points) => {
  const normalizedPoints = normalizePolygonPoints(points);
  if (normalizedPoints.length < 3) return "";

  const firstPoint = normalizedPoints[0];
  const lastPoint = normalizedPoints[normalizedPoints.length - 1];
  const isClosed = firstPoint.x === lastPoint.x && firstPoint.y === lastPoint.y;
  const closedPoints = isClosed
    ? normalizedPoints
    : [...normalizedPoints, firstPoint];

  return `POLYGON((${closedPoints.map((point) => `${point.x} ${point.y}`).join(", ")}))`;
};

export const polygonWktToPoints = (wkt) => {
  if (typeof wkt !== "string") return [];

  const matchedPolygon = wkt.trim().match(/^POLYGON\s*\(\((.+)\)\)$/i);
  if (!matchedPolygon?.[1]) return [];

  const parsedPoints = matchedPolygon[1]
    .split(",")
    .map((pair) => pair.trim().split(/\s+/))
    .map(([x, y]) => ({ x: Number(x), y: Number(y) }))
    .filter((point) => Number.isFinite(point.x) && Number.isFinite(point.y));

  if (parsedPoints.length > 1) {
    const firstPoint = parsedPoints[0];
    const lastPoint = parsedPoints[parsedPoints.length - 1];
    if (firstPoint.x === lastPoint.x && firstPoint.y === lastPoint.y) {
      parsedPoints.pop();
    }
  }

  return parsedPoints;
};

export const testPolygonWktRead = () => {
  const sampleWkt = "POLYGON((100 120, 240 120, 240 260, 100 260, 100 120))";
  const points = polygonWktToPoints(sampleWkt);

  return {
    passed:
      points.length === 4 &&
      points[0]?.x === 100 &&
      points[0]?.y === 120 &&
      points[3]?.x === 100 &&
      points[3]?.y === 260,
    sampleWkt,
    points,
  };
};

const parseCsvLine = (line) => {
  const values = [];
  let currentValue = "";
  let inQuotes = false;

  for (let i = 0; i < line.length; i += 1) {
    const char = line[i];

    if (char === '"') {
      if (inQuotes && line[i + 1] === '"') {
        currentValue += '"';
        i += 1;
      } else {
        inQuotes = !inQuotes;
      }
      continue;
    }

    if (char === "," && !inQuotes) {
      values.push(currentValue);
      currentValue = "";
      continue;
    }

    currentValue += char;
  }

  values.push(currentValue);
  return values;
};

const Fusion2DToolbar = ({
  showForm,
  formData,
  onFormChange,
  onSaveRoom,
  isEditing,
  onCancel,
  onCreateNewRoom,
  onDeleteRoom,
  onToggleRoomVisibility,
  onSelectRoom,
  selectedPolygonId,
  canSave,
  hasUnsavedPolygon,
  savedPolygons,
  onImportRooms,
  onLoadRooms,
  selectedTool,
  buildingName,
  floorName
}) => {
  const [showExportWarning, setShowExportWarning] = useState(false);
  const [importMessage, setImportMessage] = useState(null);
  const [orderedRooms, setOrderedRooms] = useState(savedPolygons);
  const [draggedRoomId, setDraggedRoomId] = useState(null);
  const [dropTargetRoomId, setDropTargetRoomId] = useState(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (!hasUnsavedPolygon) setShowExportWarning(false);
  }, [hasUnsavedPolygon]);

  useEffect(() => {
    setOrderedRooms((previousRooms) => {
      if (!Array.isArray(savedPolygons) || savedPolygons.length === 0) {
        return [];
      }

      if (!Array.isArray(previousRooms) || previousRooms.length === 0) {
        return savedPolygons;
      }

      const savedRoomMap = new Map(
        savedPolygons.map((room) => [room.id, room]),
      );
      const nextRooms = previousRooms
        .map((room) => savedRoomMap.get(room.id))
        .filter(Boolean);

      savedPolygons.forEach((room) => {
        if (!nextRooms.some((existingRoom) => existingRoom.id === room.id)) {
          nextRooms.push(room);
        }
      });

      return nextRooms;
    });
  }, [savedPolygons]);

  const handleExportAttempt = () => {
    if (hasUnsavedPolygon) {
      setShowExportWarning(true);
    }
  };

  const handleUploadButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleSyncRooms = async () => {
    if (typeof onLoadRooms !== "function") return;

    await onLoadRooms();
  };

  const handleRoomDragStart = (event, roomId) => {
    setDraggedRoomId(roomId);
    setDropTargetRoomId(roomId);
    event.dataTransfer.effectAllowed = "move";
    event.dataTransfer.setData("text/plain", String(roomId));
  };

  const handleRoomDragOver = (event, roomId) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
    setDropTargetRoomId(roomId);
  };

  const handleRoomDrop = (event, targetRoomId) => {
    event.preventDefault();

    setOrderedRooms((previousRooms) => {
      if (!draggedRoomId || draggedRoomId === targetRoomId) {
        return previousRooms;
      }

      const draggedIndex = previousRooms.findIndex(
        (room) => room.id === draggedRoomId,
      );
      const targetIndex = previousRooms.findIndex(
        (room) => room.id === targetRoomId,
      );

      if (draggedIndex < 0 || targetIndex < 0) {
        return previousRooms;
      }

      const nextRooms = [...previousRooms];
      const [draggedRoom] = nextRooms.splice(draggedIndex, 1);
      nextRooms.splice(targetIndex, 0, draggedRoom);
      return nextRooms;
    });

    setDraggedRoomId(null);
    setDropTargetRoomId(null);
  };

  const handleRoomDragEnd = () => {
    setDraggedRoomId(null);
    setDropTargetRoomId(null);
  };

  const handleCsvUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const parserTest = testPolygonWktRead();
    if (!parserTest.passed) {
      setImportMessage({
        type: "error",
        text: "Polygon parser self-test failed. CSV upload is blocked.",
      });
      event.target.value = "";
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      try {
        const text = String(reader.result || "");
        const lines = text
          .split(/\r?\n/)
          .map((line) => line.trim())
          .filter((line) => line.length > 0);

        if (lines.length < 2) {
          setImportMessage({
            type: "error",
            text: "CSV is empty or missing data rows.",
          });
          return;
        }

        const headers = parseCsvLine(lines[0]).map((header) => header.trim());
        const importedRooms = [];
        let skippedRows = 0;

        for (let i = 1; i < lines.length; i += 1) {
          const columns = parseCsvLine(lines[i]);
          const row = {};

          headers.forEach((header, index) => {
            row[header] = (columns[index] || "").trim();
          });

          const polygonWKT =
            row.polygonWKT ||
            row.polygonWkt ||
            row.PolygonWKT ||
            row.POLYGONWKT ||
            "";

          const points = polygonWktToPoints(polygonWKT);
          if (points.length < 3) {
            skippedRows += 1;
            continue;
          }

          importedRooms.push({
            roomName: row.roomName || row.Room || "Untitled",
            roomType: row.roomType || "",
            area: Number(row.area) || 0,
            floorType: row.floorType || "",
            carpetType: row.carpetType || "",
            fixedFurniture: row.fixedFurniture || "",
            highTouchAreas: row.highTouchAreas || false,
            notes: row.notes || "",
            points,
          });
        }

        if (importedRooms.length === 0) {
          setImportMessage({
            type: "error",
            text: "No valid polygon rows found. Ensure the CSV has a polygonWKT column.",
          });
          return;
        }

        if (typeof onImportRooms === "function") {
          onImportRooms(importedRooms);
        }

        setImportMessage({
          type: "success",
          text: `Imported ${importedRooms.length} room(s). Skipped ${skippedRows} invalid row(s).`,
        });
      } catch (error) {
        setImportMessage({
          type: "error",
          text: "Failed to parse CSV file.",
        });
      }
    };

    reader.readAsText(file);
    event.target.value = "";
  };

  const csvData = savedPolygons.map((room) => ({
    "Building Name": buildingName,
    "Floor Name": floorName,
    "Floor Level": room.floorLevel,
    "Room Number": room.roomName,
    "Room Name": room.roomType,
    "Actual SQFT": room.area,
    "Area Type": room.areaType,
    "Custodial Space Type": room.custodialSpaceType,
    "Custodial Space": room.custodialSpace,
    "Location ID": room.locationID,
    Fixtures: room.fixedFurniture,
    "Floor Type": room.floorType,
    "Building Code": room.buildingCode,
    Active: room.active,
    "Custodial Template Code": room.custodialTemplateCode,
    // carpetType: room.carpetType,
    // highTouchAreas: room.highTouchAreas,
    // notes: room.notes,
    // polygonWKT: polygonPointsToWkt(room.points || room.polygonPoints),
  }));

  return (
    <div
      style={{
        width: 360,
        minWidth: 320,
        overflowY: "auto",
        padding: 12,
        marginTop: 20,
      }}
    >
      {selectedTool === "draw" && (
        <button
          type="button"
          onClick={onCreateNewRoom}
          style={{
            width: "100%",
            border: "none",
            borderRadius: 6,
            background: "#112138",
            color: "#fff",
            height: 32,
            fontSize: 12,
            fontWeight: 500,
            cursor: "pointer",
            marginBottom: 10,
          }}
        >
          Create New Room
        </button>
      )}
      {selectedPolygonId && (
        <div
          style={{
            fontSize: 18,
            fontWeight: 700,
            marginBottom: 8,
            color: "#1f2a44",
          }}
        >
          Edit Room
        </div>
      )}

      {showForm && (
        <div
          style={{
            background: "white",
            borderRadius: 8,
            border: "1px solid #d7e0ec",
            padding: 12,
            marginBottom: 12,
          }}
        >
          <div
            style={{
              background: "#f8fafc",
              border: "1px solid #d7e0ec",
              color: "#4e5d78",
              fontSize: 12,
              borderRadius: 6,
              padding: "8px 10px",
              marginBottom: 10,
              lineHeight: 1.4,
            }}
          >
            {selectedPolygonId
              ? "Adjust the room boundary on the map, then click Update to save or Cancel to discard."
              : "Draw or update the room shape on the map, then review the room details here."}
          </div>

          {/* Legend */}
          {/* <div className="d-flex flex-row align-center justify-content-start mb-2">
            <div
              style={{
                width: 12,
                height: 12,
                background: "#1f2a44",
                borderRadius: 3,
                marginRight: 6,
              }}
            ></div>
            <span style={labelStyle}>Auto-populated field</span>
          </div> */}

          <div style={{ marginBottom: 10 }}>
            <span style={labelStyle}>Floor Level</span>
            <input
              name="floorLevel"
              value={formData.floorLevel}
              onChange={onFormChange}
              placeholder="Eg: A04-0126-1-4-1475"
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: 10 }}>
            <div className="d-flex flex-row align-center justify-content-between mb-1">
              <span style={labelStyle}>Room Number</span>
              {/* <div
                style={{
                  width: 12,
                  height: 12,
                  background: "#1f2a44",
                  borderRadius: 3,
                  marginRight: 6,
                }}
              ></div> */}
            </div>

            <input
              name="roomName"
              value={formData.roomName}
              onChange={onFormChange}
              placeholder="Eg: A100A"
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: 10 }}>
            <div className="d-flex flex-row align-center justify-content-between mb-1">
              <span style={labelStyle}>Room Name</span>
              {/* <div
                style={{
                  width: 12,
                  height: 12,
                  background: "#1f2a44",
                  borderRadius: 3,
                  marginRight: 6,
                }}
              ></div> */}
            </div>

            <input
              name="roomType"
              value={formData.roomType}
              onChange={onFormChange}
              placeholder="Eg: Office"
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: 12 }}>
            <div className="d-flex flex-row align-center justify-content-between mb-1">
              <span style={labelStyle}>Actual SQFT</span>
              {/* <div
                style={{
                  width: 12,
                  height: 12,
                  background: "#1f2a44",
                  borderRadius: 3,
                  marginRight: 6,
                }}
              ></div> */}
            </div>
            <div style={inputStyle}>
              {Number.isFinite(formData.area) ? formData.area : ""}
            </div>
            <div
              style={{
                marginTop: 4,
                fontSize: 10,
                color: "#94a3b8",
                fontStyle: "italic",
                letterSpacing: 0.1,
                lineHeight: 1.4,
              }}
            >
              Calculated automatically from the room shape.
            </div>
          </div>

          <div style={{ marginBottom: 10 }}>
            <span style={labelStyle}>Area Type</span>

            <select
              name="areaType"
              value={formData.areaType}
              onChange={onFormChange}
              style={inputStyle}
            >
              <option value="">Select Area Type</option>
              {aramakAreaTypes.map((type) => (
                <option key={type.id} value={type.description}>
                  {type.description}
                </option>
              ))}
            </select>
          </div>

          <div style={{ marginBottom: 10 }}>
            <span style={labelStyle}>Custodial Space Type</span>

            <select
              name="custodialSpaceType"
              value={formData.custodialSpaceType}
              onChange={onFormChange}
              style={inputStyle}
            >
              <option value="">Select Space Type</option>
              {aramakCustodialSpaceTypes.map((type) => (
                <option key={type.id} value={type.description}>
                  {type.description}
                </option>
              ))}
            </select>
          </div>
          <div style={{ marginBottom: 10 }}>
            <span style={labelStyle}>Custodial Space</span>

            <input
              name="custodialSpace"
              value={formData.custodialSpace}
              onChange={onFormChange}
              placeholder="Eg: 1"
              style={inputStyle}
            />
          </div>
          <div style={{ marginBottom: 10 }}>
            <span style={labelStyle}>Location ID</span>

            <input
              name="locationID"
              value={formData.locationID}
              onChange={onFormChange}
              placeholder="Eg: A04-0126 - A100A"
              style={inputStyle}
            />
          </div>
          <div style={{ marginBottom: 10 }}>
            <span style={labelStyle}>Custodial Priority</span>

            <input
              name="custodialPriority"
              value={formData.custodialPriority}
              onChange={onFormChange}
              placeholder="Eg: 3"
              style={inputStyle}
            />
          </div>

          <hr style={{ borderColor: "#e1e8f0", margin: "10px 0" }} />

          <div style={sectionTitleStyle}>ROOM DETAILS</div>
          <div style={{ marginBottom: 10 }}>
            <div className="d-flex flex-row align-center justify-content-between mb-1">
            <span style={labelStyle}>Fixtures</span>
              {/* <div
                style={{
                  width: 12,
                  height: 12,
                  background: "#1f2a44",
                  borderRadius: 3,
                  marginRight: 6,
                }}
              ></div> */}
            </div>
            <input
              name="fixedFurniture"
              value={formData.fixedFurniture}
              onChange={onFormChange}
              placeholder="Eg: 3"
              style={inputStyle}
            />
          </div>
          <div style={{ marginBottom: 10 }}>
            <span style={labelStyle}>Floor Type</span>
            <select
              name="floorType"
              value={formData.floorType}
              onChange={onFormChange}
              style={inputStyle}
            >
              <option value="">Select Floor Type</option>
              {aramakFloorTypes.map((type) => (
                <option key={type.id} value={type.description}>
                  {type.description}
                </option>
              ))}
            </select>
          </div>

          <div style={{ marginBottom: 10 }}>
            <span style={labelStyle}>Building Code</span>
            <input
              name="buildingCode"
              value={formData.buildingCode}
              onChange={onFormChange}
              placeholder="Eg: A04-0126"
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: 10 }}>
            <span style={labelStyle}>Active</span>
            <select
              name="active"
              value={formData.active}
              onChange={onFormChange}
              style={inputStyle}
            >
              <option value={1}>Active</option>
              <option value={0}>Inactive</option>
            </select>
          </div>

          <div style={{ marginBottom: 10 }}>
            <span style={labelStyle}>Custodial Template Code</span>
            <input
              name="custodialTemplateCode"
              value={formData.custodialTemplateCode}
              onChange={onFormChange}
              placeholder="000000125-Work RoomHS"
              style={inputStyle}
            />
          </div>

          <hr style={{ borderColor: "#e1e8f0", margin: "10px 0" }} />

          <div style={sectionTitleStyle}>
            OTHERS (Leave empty if not applicable)
          </div>
          <div style={{ marginBottom: 12 }}>
            <span style={labelStyle}>Carpet Type</span>
            <input
              name="carpetType"
              value={formData.carpetType}
              onChange={onFormChange}
              placeholder="Not specified"
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: 10 }}>
            <span style={labelStyle}>High-Touch Areas</span>
            <select
              name="highTouchAreas"
              value={formData.highTouchAreas}
              onChange={onFormChange}
              style={inputStyle}
            >
              <option value={false}>No</option>
              <option value={true}>Yes</option>
            </select>
          </div>

          <div style={{ marginBottom: 14 }}>
            <span style={labelStyle}>Notes</span>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={onFormChange}
              placeholder="Add cleaning notes..."
              rows={2}
              style={{ ...inputStyle, resize: "vertical" }}
            />
          </div>

          <div style={{ display: "flex", gap: 8 }}>
            <ActionButton onClick={onSaveRoom} disabled={!canSave}>
              {isEditing ? "Update Room" : "Save Room"}
            </ActionButton>
            <ActionButton onClick={onCancel} variant="secondary">
              Cancel
            </ActionButton>
            {/* <ActionButton onClick={onDeleteRoom} variant="secondary">Delete</ActionButton> */}
          </div>
        </div>
      )}

      <div style={{ marginBottom: 10 }}>
        <button
          type="button"
          onClick={handleSyncRooms}
          style={{
            width: "100%",
            border: "none",
            borderRadius: 6,
            background: "#112138",
            color: "#fff",
            height: 32,
            fontSize: 12,
            fontWeight: 500,
            cursor: "pointer",
          }}
        >
          Sync Room Scan
        </button>
      </div>

      <div style={{ marginBottom: 10 }}>
        {savedPolygons.length > 0 && !hasUnsavedPolygon ? (
          <CSVLink
            data={csvData}
            filename="rooms.csv"
            style={{ textDecoration: "none" }}
          >
            <button
              type="button"
              style={{
                width: "100%",
                border: "none",
                borderRadius: 6,
                background: "#112138",
                color: "#fff",
                height: 32,
                fontSize: 12,
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              Export All Rooms (CSV)
            </button>
          </CSVLink>
        ) : (
          <button
            type="button"
            onClick={handleExportAttempt}
            disabled={savedPolygons.length === 0}
            style={{
              width: "100%",
              border: "none",
              borderRadius: 6,
              background: savedPolygons.length === 0 ? "#dbe2eb" : "#112138",
              color: "#fff",
              height: 32,
              fontSize: 12,
              fontWeight: 500,
              cursor: savedPolygons.length === 0 ? "not-allowed" : "pointer",
            }}
          >
            Export All Rooms (CSV)
          </button>
        )}
      </div>

      {importMessage && (
        <div
          style={{
            background:
              importMessage.type === "success" ? "#e8f7ed" : "#ffe7e1",
            color: importMessage.type === "success" ? "#1f6f3f" : "#a54545",
            border:
              importMessage.type === "success"
                ? "1px solid #c8ebd5"
                : "1px solid #ffcbc0",
            borderRadius: 6,
            padding: "10px 12px",
            fontSize: 12,
            marginBottom: 10,
          }}
        >
          {importMessage.text}
        </div>
      )}

      {showExportWarning && (
        <div
          style={{
            background: "#ffe7e1",
            color: "#a54545",
            border: "1px solid #ffcbc0",
            borderRadius: 6,
            padding: "10px 12px",
            fontSize: 12,
            marginBottom: 10,
          }}
        >
          There are unsaved rooms on this map. To include it in the export, save
          the new room.
        </div>
      )}

      <div
        style={{
          fontSize: 18,
          fontWeight: 700,
          marginBottom: 8,
          color: "#1f2a44",
        }}
      >
        Existing Rooms
      </div>

      {/* {savedPolygons.length > 0 && (
        <div
          style={{
            fontSize: 11,
            color: "#7d8da6",
            marginBottom: 8,
            display: "flex",
            alignItems: "center",
            gap: 6,
          }}
        >
          <DragIndicatorRoundedIcon sx={{ fontSize: 16, color: "#9aa8bc" }} />
          Drag rooms to reorder the list.
        </div>
      )} */}

      {savedPolygons.length === 0 ? (
        <div style={{ color: "#60738f", fontSize: 12 }}>No rooms found.</div>
      ) : (
        <div
          style={{
            display: "grid",
            gap: 10,
            maxHeight: "38vh",
            overflowY: "auto",
            paddingRight: 4,
          }}
        >
          {orderedRooms.map((room) => (
            <div
              key={room.id}
              aria-selected={room.id === selectedPolygonId}
              // draggable
              // onDragStart={(event) => handleRoomDragStart(event, room.id)}
              // onDragOver={(event) => handleRoomDragOver(event, room.id)}
              // onDrop={(event) => handleRoomDrop(event, room.id)}
              // onDragEnd={handleRoomDragEnd}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: 13,
                color: "#1f2a44",
                padding: "8px 10px",
                borderRadius: 6,
                background:
                  draggedRoomId === room.id
                    ? "#f8fafc"
                    : room.id === selectedPolygonId
                      ? "#edf2f7"
                      : "#ffffff",
                border:
                  dropTargetRoomId === room.id && draggedRoomId !== room.id
                    ? "2px dashed #60738f"
                    : room.id === selectedPolygonId
                      ? "2px solid #112138"
                      : "1px solid #e6ecf4",
                opacity: room.hidden ? 0.65 : 1,
                boxShadow:
                  dropTargetRoomId === room.id && draggedRoomId !== room.id
                    ? "0 0 0 2px rgba(96, 115, 143, 0.12)"
                    : room.id === selectedPolygonId
                      ? "0 0 0 2px rgba(17, 33, 56, 0.12)"
                      : "none",
                transform:
                  draggedRoomId === room.id ? "scale(0.99)" : "translateY(0)",
                transition:
                  "border-color 120ms ease, box-shadow 120ms ease, background-color 120ms ease, transform 120ms ease",
                cursor: "grab",
              }}
            >
              {/* <span
                aria-hidden="true"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: draggedRoomId === room.id ? "#112138" : "#9aa8bc",
                  marginRight: 10,
                  flexShrink: 0,
                }}
              >
                <DragIndicatorRoundedIcon sx={{ fontSize: 18 }} />
              </span> */}
              <button
                type="button"
                onClick={() => onSelectRoom(room.id)}
                aria-pressed={room.id === selectedPolygonId}
                style={{
                  cursor: "pointer",
                  flex: 1,
                  textAlign: "left",
                  border: "none",
                  background: "transparent",
                  color: "inherit",
                  padding: 0,
                  fontSize: 13,
                  opacity: room.hidden ? 0.7 : 1,
                }}
              >
                {room.roomName || "Untitled"} -{" "}
                {Number(room.area || 0).toFixed(1)} SQFT
              </button>
              {room.hidden && (
                <span
                  style={{
                    marginRight: 8,
                    padding: "2px 6px",
                    borderRadius: 999,
                    fontSize: 10,
                    fontWeight: 700,
                    letterSpacing: 0.2,
                    color: "#556987",
                    background: "#eef2f7",
                    border: "1px solid #d6dce5",
                  }}
                >
                  Hidden
                </span>
              )}
              {room.id === selectedPolygonId && (
                <span
                  style={{
                    marginRight: 8,
                    padding: "2px 6px",
                    borderRadius: 999,
                    fontSize: 10,
                    fontWeight: 700,
                    letterSpacing: 0.2,
                    color: "#112138",
                    background: "#dbe2eb",
                    border: "1px solid #bac6d6",
                  }}
                >
                  Selected
                </span>
              )}
              <button
                type="button"
                onClick={() => onToggleRoomVisibility(room.id)}
                aria-label={
                  room.hidden ? "Show room on canvas" : "Hide room on canvas"
                }
                title={
                  room.hidden ? "Show room on canvas" : "Hide room on canvas"
                }
                style={{
                  border: "none",
                  background: "transparent",
                  color: room.hidden ? "#556987" : "#112138",
                  cursor: "pointer",
                  fontSize: 14,
                  marginRight: 4,
                  padding: 0,
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                {room.hidden ? (
                  <VisibilityRoundedIcon />
                ) : (
                  <VisibilityOffRoundedIcon />
                )}
              </button>
              <button
                type="button"
                onClick={() => onDeleteRoom(room)}
                style={{
                  border: "none",
                  background: "transparent",
                  color: "#7b8ca7",
                  cursor: "pointer",
                  fontSize: 14,
                }}
              >
                <DeleteForeverRoundedIcon color="error" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Fusion2DToolbar;
